import { Card, CardMedia } from '@mui/material';

const Home = () => {
  return (
    <Card>
      <CardMedia
        component="img"
        image="https://source.unsplash.com/R10kxddJNWk"
      />
    </Card>
  );
};

export default Home;